import * as React from 'react';

import './index.css';
import Colors from './components/Colors';
import Section from './components/Section';
import Shadows from './components/Shadows';
import Icons from './components/Icons';

export default class App extends React.Component {
  render() {
    return (
      <div className="body">
        <h1>
          Santa Closet cheat sheet
          <span role="img" aria-label="santa" />
        </h1>
        <div className="content">
          <Section title="Colors" col="col-2">
            <Colors />
          </Section>
          <Section title="Theme" col="col-2">
            <Colors theme="dark" key="dark" />
            <Colors theme="light" key="light" />
          </Section>
          <Section title="Shadows" col="col-2">
            <Shadows />
          </Section>
          <Section title="Icons">
            <Icons />
          </Section>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js